var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 20.925q-.65 0-1.087-.45-.438-.45-.438-1.1V5.7q0-.65.438-1.1.437-.45 1.087-.45h6.375v.925H5.875q-.225 0-.412.187-.188.188-.188.438v13.675q0 .25.188.437.187.188.412.188h6.375v.925Zm10.375-5-.65-.625 2.275-2.3h-8.6v-.925h8.6L15.6 9.8l.65-.675 3.4 3.4Z"
  })));
};

export { SvgLogout as ReactComponent };
export default __webpack_public_path__ + "logout.svg";